import { render, staticRenderFns } from "./TypesTableMobile.vue?vue&type=template&id=eb9ad95c&lang=pug&"
import script from "./TypesTableMobile.vue?vue&type=script&lang=js&"
export * from "./TypesTableMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports